import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import "./index.css"
import store from './store';
import withNavigationWatcher from "./withNavigationWatcher.js";
const AppWithWatcher = withNavigationWatcher(App);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Provider store={store}>
        <BrowserRouter>
            <AppWithWatcher />
        </BrowserRouter>
    </Provider>
);

serviceWorker.unregister();